export default __webpack_public_path__ + "static/media/vote-getter-img.04dffc48.jpg";